export var PRINT_HIDE_CLASS = 'printHide';
